import React, { useEffect, useState } from "react";
import SignupForm from "../../components/signupForm/SignupForm";
import axiosClient from "../../api/axiosClient";
import { Navigate, useParams } from "react-router-dom";
import CreatePasswordForm from "../../components/createPasswordForm/CreatePasswordForm";
import Success from "../../components/success/Success";
import Error from "../../components/Error/Error";
import Loading from "../../components/loading/Loading";
import LoadingOverlay from "../../components/loadingOverlay/LoadingOverlay";
import { useAuth } from "../../contexts/AuthContext";

const Signup = () => {
  const {isAuthenticated, doLogout} = useAuth();
  const [clinicalSiteList, setClinicalSiteList] = useState([]);
  const [healthSystemList, setHealthSystemsList] = useState([]);
  const [specialityList, setSpecialityList] = useState([]);
  const [singupData, setSignupData] = useState({
    firstName: '',
    lastName: '',
    healthSystemIds: [],
    clinicalSitesIds: [],
    speciality: '',
    specialityIds: []
  });
  const [view, setView] = useState('loading');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [tokenError, setTokenError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [subscriptionId, setSubscrptionId] = useState(null);
  const { signupToken } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      await axiosClient.get(`auth/registration/${signupToken}`)
      .then ((response) => {
        let signUpData = {
          firstName: response.data?.firstName,
          lastName: response.data?.lastName,
        }
        if(response.data?.healthSystems) {
          signUpData.healthSystemIds = response.data.healthSystems.map((item) => item.id);
        }
        if(response.data?.clinicalSites) {
          signUpData.clinicalSiteIds = response.data.clinicalSites.map((item) => item.id);
        }
        if(response.data?.speciality) {
          signUpData.speciality = response.data.speciality?.name;
        }
        if(response.data?.specialities) {
          signUpData.specialityIds = response.data.specialities.map((item) => item.id);
        }
        if(response.data?.role) {
          signUpData.role = response.data.role.role;
        }
        setSignupData((prevData) => {
          return {
            ...prevData,
            ...signUpData
          }
        });
        if(response.data?.subscription) {
          setSubscrptionId(response.data.subscription?.id)
        }
        setView('signup');
        axiosClient.get('specialities')
        .then ((specialityResponse) => {
          setSpecialityList(specialityResponse.data.map((item) => ({
            value: item.id,
            label: item.name
          })));
        });
      })
      .catch((error) => {
        setTokenError(error.message);
        setView('error');
      });
    };

    fetchData();
  }, [signupToken]);

  useEffect(() => {
    const fetchData = async () => {
      await axiosClient.get(`health-systems/subscription/${subscriptionId}`)
      .then((response) => {
        setHealthSystemsList(response.data.map((item) => ({
          value: item.id,
          label: item.name
        })));
      })
    };

    if(subscriptionId) {
      fetchData();
    }
  }, [subscriptionId]);

  useEffect(() => {
    const fetchData = async () => {
      await axiosClient.get(`clinical-sites`, {
        params: {
          healthSystemIds: singupData.healthSystemIds.join(',')
        }
      })
      .then((response) => {
        setClinicalSiteList(response.data.map((item) => ({
          value: item.id,
          label: item.name
        })));
      })
    };

    if(singupData.healthSystemIds && singupData.healthSystemIds.length > 0) {
      fetchData();
    } else {
      setClinicalSiteList([]);
    }
  }, [singupData.healthSystemIds]);

  const handleSignup = (data) => {
    setSignupData(data);
    setView('password')
  };

  const handlePassword = async (password) => {
    setIsLoading(true);
    await axiosClient.post(`auth/registration/${signupToken}`, {
      ...singupData,
      password,
    })
    .then((data) => {
      setSuccessMessage(data.message);
      setView('success');
      if(isAuthenticated) {
        doLogout();
      }
    })
    .catch((error) => {
      setError(error.message);
    })
    .finally(() => {
      setIsLoading(false);
    });
  }

  switch (view) {
    case 'loading': 
      return (
        <Loading />
      );
    case 'signup' : 
      return (
        <SignupForm
          formData={singupData}
          healthSystemList={healthSystemList}
          onHealthSystemChange={(healthSystemIds) => {
            setSignupData((prevData) => {
              return {
                ...prevData,
                healthSystemIds: healthSystemIds
              }
            });
          }}
          clinicalSiteList={clinicalSiteList}
          specialityList={specialityList}
          onSubmit={handleSignup}
          error={error}
        />
      );
    case 'password' :
      return (
        <>
          {isLoading && <LoadingOverlay />}
          <CreatePasswordForm
            onSubmit={handlePassword}
            error={error}
          />
        </>
      );
    case 'success' :
      return (
        <Success message={successMessage} />
      );
    case 'error' :
      return (
        <Error message={tokenError} />
      );
    default : return <Navigate to="/login" />
  }
};

export default Signup;